import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookieName, ProductName } from '../constants/product-domain';
import * as i0 from "@angular/core";
import * as i1 from "@legalzoom/web-session-sdk";
import * as i2 from "../state/app/app.service";
import * as i3 from "ngx-cookie/src/cookie.service";
import * as i4 from "@legalzoom/business-formation-sdk";
import * as i5 from "@legalzoom/lib-checkout";
export class AuthService {
    constructor(webSessionService, appService, cookieService, trackJS, helperService) {
        this.webSessionService = webSessionService;
        this.appService = appService;
        this.cookieService = cookieService;
        this.trackJS = trackJS;
        this.helperService = helperService;
    }
    getAuthToken() {
        return this.currentToken;
    }
    refreshToken() {
        const app = this.appService.app;
        const sessionId = app.sessionId;
        const authToken = app.accessToken;
        return this.webSessionService.refreshOAuth2Token(authToken, sessionId)
            .pipe(map(refreshOAuth2TokenResponse => {
            app.accessToken = refreshOAuth2TokenResponse.accessToken;
            this.appService.app = app;
            const cookieDomain = window.location.hostname === 'localhost' ? 'localhost' : 'legalzoom.com';
            const cookieOptions = { domain: cookieDomain, storeUnencoded: true };
            this.cookieService.put(CookieName.USERIDENTIFICATION, 'consultation_id=' + decodeURIComponent(refreshOAuth2TokenResponse.accessToken) +
                '&cid=' + this.appService.app.customerId, cookieOptions);
            this.refreshCheckoutToken(refreshOAuth2TokenResponse.accessToken);
            return this.currentToken = refreshOAuth2TokenResponse.accessToken;
        }));
    }
    refreshCheckoutToken(token) {
        this.helperService.updateToken(token);
    }
    prepareGetCustomerAndSession(sessionId, authToken, customerId) {
        return {
            name: 'prepareGetCustomerAndSession auth.service',
            // clearQueueOnError: false,
            pre: () => {
                return this.webSessionService.getCustomerAndSession(sessionId, '', customerId);
            },
            post: (response) => {
                const appState = this.appService.app;
                appState.customerId = response.customerId;
                appState.accessToken = authToken;
                appState.sessionId = response.session.find(s => s.key === 'TIMESTRING').value;
                appState.loginEmail = response.session.find(s => s.key === 'UserName').value;
                this.appService.app = appState;
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'auth.service', error);
                return of(null);
            }
        };
    }
}
AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.WebSessionService), i0.ɵɵinject(i2.AppService), i0.ɵɵinject(i3.CookieService), i0.ɵɵinject(i4.TrackJsErrorLogService), i0.ɵɵinject(i5.HelperService)); }, token: AuthService, providedIn: "root" });
